import React from 'react';
import './LanguageSwitcher.css';

interface LanguageSwitcherProps {
  currentLanguage: string;
  onLanguageChange: (language: string) => void;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ 
  currentLanguage, 
  onLanguageChange 
}) => {
  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'tr', name: 'Türkçe', flag: '🇹🇷' }
  ];

  return (
    <div className="language-switcher">
      {languages.map((language) => (
        <button
          key={language.code}
          onClick={() => onLanguageChange(language.code)}
          className={`language-flag ${currentLanguage === language.code ? 'active' : ''}`}
          title={language.name}
        >
          <span className="flag-icon">{language.flag}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
